import { FormControl, FormLabel, Stack, Input, Textarea, Box, Badge } from "@chakra-ui/react";

export default function BilingualField({ label, valueEs, valueEn, onChangeEs, onChangeEn, type = "input", required = false }) {
  const C = type === "textarea" ? Textarea : Input;
  return (
    <FormControl isRequired={required}>
      <FormLabel>{label}</FormLabel>
      <Stack direction={{ base: "column", md: "row" }} align="start" spacing={3}>
        <Box flex="1" width="100%">
          <Badge mb={1}>ES</Badge>
          <C value={valueEs || ""} onChange={(e) => onChangeEs(e.target.value)} />
        </Box>
        <Box flex="1" width="100%">
          <Badge mb={1}>EN</Badge>
          <C value={valueEn || ""} onChange={(e) => onChangeEn(e.target.value)} />
        </Box>
      </Stack>
    </FormControl>
  );
}
